import masker from "vue-the-mask/src/masker"
import tokens from "vue-the-mask/src/tokens"

export function promiseWrapper(promise, thenFunction, catchFunction) {
  return new Promise((resolve, reject) => {
    promise.then((res) => {
      thenFunction(res)
      return resolve(res)
    }).catch((err) => {
      catchFunction(err)
      return reject(err)
    })
  })
}


const toCamel = (s) => {
  return s.replace(/([-_][a-z])/ig, ($1) => {
    return $1.toUpperCase().replace("-", "").replace("_", "")
  })
}


const isArray = function (a) {
  return Array.isArray(a)
}


const isObject = function (o) {
  return o === Object(o) && !isArray(o) && typeof o !== "function"
}


export const keysToCamel = function (o) {
  if (isObject(o)) {
    const n = {}

    Object.keys(o).forEach((k) => {
      n[toCamel(k)] = keysToCamel(o[k])
    })
    return n
  } else if (isArray(o)) {
    return o.map((i) => {
      return keysToCamel(i)
    })
  }
  return o
}


export function getFileExtension(filename) {
  // https://stackoverflow.com/a/1203361/10106533
  return filename.substring(filename.lastIndexOf(".") + 1, filename.length) || filename
}

export function isZipMimetype(type) {
  return ["application/zip", "application/octet-stream", "application/x-zip-compressed", "multipart/x-zip"].includes(type)
}


export function readFileAsync(file) {
  // Reference: https://simon-schraeder.de/posts/filereader-async/

  return new Promise((resolve, reject) => {
    let reader = new FileReader()

    reader.onload = () => {
      resolve(reader.result)
    }

    reader.onerror = reject

    reader.readAsArrayBuffer(file)
  })
}


export function luhnCheck(cardNum) {
  // Luhn Check Code from https://gist.github.com/4075533
  // accept only digits, dashes or spaces
  let numericDashRegex = /^[\d\-\s]+$/
  if (!numericDashRegex.test(cardNum)) return false

  // The Luhn Algorithm. It's so pretty.
  let nCheck = 0, nDigit = 0, bEven = false
  let strippedField = cardNum.replace(/\D/g, "")

  for (let n = strippedField.length - 1; n >= 0; n--) {
    let cDigit = strippedField.charAt(n)
    nDigit = parseInt(cDigit, 10)
    if (bEven) {
      if ((nDigit *= 2) > 9) nDigit -= 9
    }

    nCheck += nDigit
    bEven = !bEven
  }

  return (nCheck % 10) === 0
}

const DDD_NUMBERS = [11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99]

export function phoneNumberValidation(prefix, number) {
  return !((prefix.length !== 2 && !DDD_NUMBERS.includes(prefix)) || (number.length !== 8 && number.length !== 9))
}

export const documentNumberValidation = (number) => {
  function buildDigit(arr) {
    let isCpf = arr.length < 11,
      digit = arr.map(function (val, idx) {
        return val * ((!isCpf ? idx % 8 : idx) + 2)
      }).reduce(function (total, current) {
        return total + current
      }) % 11
    if (digit < 2 && isCpf) return 0
    return 11 - digit
  }

  let arr

  number = number.replace(/\D/g, "")

  if ([11, 14].indexOf(number.length) < 0) return false

  arr = number.split("").reverse().slice(2)

  arr.unshift(buildDigit(arr))
  arr.unshift(buildDigit(arr))

  if (number.length >= 14) return cnpjValidation(number)

  return number === arr.reverse().join("")

}

export const cnpjValidation = (cnpj) => {

  cnpj = cnpj.replace(/[^\d]+/g, "")

  // noinspection EqualityComparisonWithCoercionJS
  if (cnpj == "") return false

  // noinspection EqualityComparisonWithCoercionJS
  if (cnpj.length != 14)
    return false

  // Elimina CNPJs invalidos conhecidos
  // noinspection EqualityComparisonWithCoercionJS
  if (cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999")
    return false

  // Valida DVs
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0, tamanho)
  let digitos = cnpj.substring(tamanho)
  let soma = 0
  let pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2)
      pos = 9
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
  // noinspection EqualityComparisonWithCoercionJS
  if (resultado != digitos.charAt(0))
    return false

  tamanho = tamanho + 1
  numeros = cnpj.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2)
      pos = 9
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
  // noinspection EqualityComparisonWithCoercionJS
  if (resultado != digitos.charAt(1))
    return false

  return true

}


export function unmask(value, mask) {
  return masker(value, mask, false, tokens)
}


export function guessCreditCardBrand(cardNum) {
  let payCardType = ""
  let regexMap = [
    {regEx: /^4[0-9]{5}/ig, cardType: "visa"},
    {regEx: /^5[1-5][0-9]{4}/ig, cardType: "mastercard"},
    {regEx: /^3[47][0-9]{3}/ig, cardType: "amex"},
    {regEx: /^(5[06-8]\d{4}|6\d{5})/ig, cardType: "maestro"},
    {
      regEx: /^^(40117[8-9]|431274|438935|451416|457393|45763[1-2]|506(699|7[0-6][0-9]|77[0-8])|509\d{3}|504175|627780|636297|636368|65003[1-3]|6500(3[5-9]|4[0-9]|5[0-1])|6504(0[5-9]|[1-3][0-9])|650(4[8-9][0-9]|5[0-2][0-9]|53[0-8])|6505(4[1-9]|[5-8][0-9]|9[0-8])|6507(0[0-9]|1[0-8])|65072[0-7]|6509(0[1-9]|1[0-9]|20)|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/ig,
      cardType: "elo",
    },
  ]

  for (let j = 0; j < regexMap.length; j++) {
    if (cardNum.match(regexMap[j].regEx)) {
      payCardType = regexMap[j].cardType
    }
  }

  if (payCardType) return payCardType

  return ""
}


export function createQueryParams(queryData) {
  let queryParams = ""
  for (const [key, val] of Object.entries(queryData)) {
    if (queryParams.length === 0)
      queryParams += `${key}=${val}`
    else
      queryParams += `&${key}=${val}`
  }

  return queryParams
}


export function toFixed(num, fixed) {
  const re = new RegExp(`^-?\\d+(?:.\\d{0,${fixed || -1}})?`)
  return num.toString().match(re)[0]
}
